import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Domains from './pages/Domains';
import DomainChecker from './components/DomainChecker';

const App = () => {
  const isLoggedIn = localStorage.getItem("admin") === "true";

  return (
    <Router>
      {isLoggedIn ? (
        <div style={{ display: 'flex' }}>
          <Sidebar />
          <div style={{ flexGrow: 1 }}>
            <Topbar />
            <div style={{ padding: '20px' }}>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/domains" element={<DomainChecker />} />
              </Routes>
            </div>
          </div>
        </div>
      ) : (
        <Login />
      )}
    </Router>
  );
};

export default App;
